import { ProductType } from 'original/constants/enums/LoanType'
import React, { useState, useMemo, useCallback } from 'react'
import Draggable from 'react-draggable'
import { Container } from 'react-bootstrap'
import { IApplicationInformation } from 'shared'
import {
	Decision,
	LifeCycleStatus,
	Status,
} from 'shared/constants/signingTypes'
import { useLocation, useNavigate } from 'react-router'
import { AllCountries, NationalityType } from 'shared/constants/countryTypes'
import {
	AccommodationType,
	ChildrenAge,
	Education,
	EmploymentSector,
	Gender,
	MaritalStatus,
	MissingKycValues,
	OccupationType,
} from 'shared/constants/kycTypes'

//let _queryValues = queryString.parse(window.location.search.toLowerCase())

export function useDeveloperTesting(func: any) {
	const [testData, setTestData] =
		useState<IApplicationInformation>(MockedModel)
	const [query, setQuery] = useState('')
	const location = useLocation()
	const navigate = useNavigate()

	const changeValue = useCallback(
		(type: NationalityType) => {
			setTestData({
				...testData,
				personalInfo: {
					firstName: 'ZeusFirs',
					lastName: 'ZeusLast',
					// ssn: '1234567',
					// birthDate: '1975-03-26',
					gender: Gender.Female,
					maritalStatus: MaritalStatus.Married,
					nationalityType: NationalityType.EU,
					nationality: AllCountries.DE,
					countryOfBirth: AllCountries.DE,
					missingKyc: [] as MissingKycValues[],
					missingKycFields: '',
				},
			})
		},
		[testData]
	)

	const onClick = useCallback(
		(e: string) => {
			const params = new URLSearchParams()
			params.append('applicationid', '300063178')
			params.append('status', e)
			navigate({ search: params.toString() })
			setQuery(e)
		},
		[location] //eslint-disable-line
	)

	const nodeRef = React.useRef(null)

	const Controls = useMemo(() => {
		return () => (
			<Draggable nodeRef={nodeRef} defaultPosition={{ x: 50, y: 100 }}>
				<div
					ref={nodeRef}
					style={{
						zIndex: 10,
						position: 'relative',
					}}>
					<Container>
						<div className={'col-12'}>
							Testing Panel
							<div
								className={'d-flex justify-content-center'}
								style={{
									backgroundColor: 'red',
								}}>
								{/* <button
									type="button"
									className="btn btn-primary col-2 m-2"
									onClick={() => onClick('success')}>
									Primary
								</button>
								<button
									type="button"
									className="btn btn-primary col-2 m-2"
									value=""
									onClick={() => onClick('ok')}>
									Sign PSD2 with callback
								</button>
								<button
									type="button"
									className="btn btn-primary col-2 m-2"
									value=""
									onClick={() => changeValue()}>
									Set amount to 1337
								</button> */}
								<button
									type="button"
									className="btn btn-primary col-2 m-2"
									value=""
									onClick={() =>
										changeValue(NationalityType.German)
									}>
									Set German citizen
								</button>
								<button
									type="button"
									className="btn btn-primary col-2 m-2"
									value=""
									onClick={() =>
										changeValue(NationalityType.NonEU)
									}>
									Set NonEU citizen
								</button>
							</div>
						</div>
					</Container>
				</div>
			</Draggable>
		)
	}, [changeValue, onClick]) //eslint-disable-line

	return { Controls, query, location, testData }
}

export const MockedModel: IApplicationInformation = {
	approvedAmount: 200000,
	approvedRepaymentPeriod: 72,
	apr: 0.32,
	decision: Decision.Approved,
	euribor: 0,
	hasCoApplicant: false,
	instalment: 102.9,
	insuranceFee: 0,
	interestRate: 0.279,
	isCoApplicant: false,
	lifeCycleStatus: LifeCycleStatus.CustomerVerification,
	loanNumber: 300063178,
	monthlyFee: 2.9,
	openingFee: 29,
	personalInfo: {
		firstName: 'ZeusFirs',
		lastName: 'ZeusLast',
		// ssn: '1234567',
		// birthDate: '1975-03-26',
		gender: Gender.Female,
		maritalStatus: MaritalStatus.Married,
		nationalityType: NationalityType.EU,
		nationality: AllCountries.DE,
		countryOfBirth: AllCountries.DE,
		missingKyc: [] as MissingKycValues[],
		missingKycFields: '',
	},
	ppi: true,
	product: ProductType.NorCredento,
	signingUrls: {
		onlineIdentification: {
			url: '',
			status: Status.NotCreated,
			isMandatory: false,
		},
		pnSigning: {
			url: 'https://preprod.signicat.com/std/docaction/bbbank?…mnr4otf909d7439b6n7u5so8gec&task_id:MainApplicant',
			status: Status.Created,
			isMandatory: false,
		},
		ppiSigning: {
			url: '',
			status: Status.NotCreated,
			isMandatory: false,
		},
		psD2: {
			url: 'https://altinnnowmock-clientUrl/f79b062f-35b4-441c-9bc8-986b5a9b0acb',
			status: Status.Created,
			isMandatory: false,
		},
	},
	topUp: { number: '', balance: 0 },
	totalAmountToBeRepaid: 200609.39,
	dateCreated: '2020.20.20',
	bankInfo: {
		accountNumber: '1234',
		iban: 'DE25110101014339847070',
		directDebitAccount: '',
		directDebitClearingNumber: '',
		directDebitIban: '',
	},
	kycUpdated: false,
	customerConsents: {
		allowMarketing: false,
		pensionRegister: false,
		processAccountData3rdParty: false,
		processData: false,
		processData3rdParty: false,
	},
	address: {
		street: 'The Street',
		streetNumber: '12',
		city: 'Cityville',
		zip: '12345',
		countryOfResidence: AllCountries.DE,
		streetType: '',
		flatNumber: '',
		careOf: '',
		regionId: 0,
	},
	accommodation: {
		cost: 20,
		type: AccommodationType.Owner,
		since: '1999-03-26',
		childrenInFamily: 1,
		salesValue: 100000,
		adultsInFamily: 1,
		childrenAge: [ChildrenAge.ElevenToFourteen],
	},
	contacts: {
		homePhone: '',
		cellPhone: '08080908080',
		officePhone: '',
		email: 'test@test.se',
	},
	employment: {
		monthlyNetIncome: 50000,
		occupationType: OccupationType.Entrepreneur,
		employerName: 'IKEA',
		employedSince: '1980-03-26',
		employmentSector: EmploymentSector.Administration,
		education: Education.ProfessEducation,
		otherIncome: '',
	},
	offer: {
		repaymentPeriodMin: 12,
		repaymentPeriodMax: 24,
		interestRate: 12,
		effectiveInterestRate: 4,
		amountMin: 1000,
		amountMax: 10000,
		maxInstallment: 500,
	},
	creditLimit: 0,
	rdi: -1000,
}

export const redirectSigningPSD2 = {
	success: (applicationId: number) =>
		`application?applicationid=${applicationId}&psd2status=success`,
	fail: (applicationId: number) =>
		`application?applicationid=${applicationId}&psd2status=fail`,
	abort: (applicationId: number) =>
		`application?applicationid=${applicationId}&psd2status=abort`,
}
export const redirectSigning = {
	success: (applicationId: number) =>
		`application?applicationid=${applicationId}&status=success`,
	fail: (applicationId: number) =>
		`application?applicationid=${applicationId}&status=fail`,
	abort: (applicationId: number) =>
		`application?applicationid=${applicationId}&status=abort`,
}
